import { useEffect } from 'react';

const FOCUSABLE = [
  'a[href]', 'button:not([disabled])', 'input:not([disabled])',
  'select:not([disabled])', 'textarea:not([disabled])', '[tabindex]:not([tabindex="-1"])',
].join(', ');

// Minimal dialog focus management for the shop overlays: when `active`, move
// focus into the dialog, keep Tab cycling inside it, and restore focus to the
// previously-focused element on close. `dep` re-runs the initial focus when the
// dialog swaps its inner view (e.g. panel -> configurator).
export default function useFocusTrap(ref, active, dep) {
  useEffect(() => {
    if (!active || !ref.current) return undefined;
    const node = ref.current;
    const previouslyFocused = document.activeElement;
    const focusable = () => [...node.querySelectorAll(FOCUSABLE)].filter((el) => el.offsetParent !== null);

    (focusable()[0] || node).focus?.();

    const onKeyDown = (e) => {
      if (e.key !== 'Tab') return;
      const items = focusable();
      if (!items.length) return;
      const first = items[0];
      const last = items[items.length - 1];
      if (e.shiftKey && document.activeElement === first) {
        e.preventDefault();
        last.focus();
      } else if (!e.shiftKey && document.activeElement === last) {
        e.preventDefault();
        first.focus();
      }
    };

    node.addEventListener('keydown', onKeyDown);
    return () => {
      node.removeEventListener('keydown', onKeyDown);
      previouslyFocused?.focus?.();
    };
  }, [ref, active, dep]);
}
